import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getClients } from "../api";
import { DocListTab, SalesDocPage } from "./SalesDocShared";

export default function TaxInvoicesPage() {
  const { data: clients = [] } = useQuery({ queryKey: ["clients"], queryFn: getClients });

  return (
    <SalesDocPage
      title="Tax Invoices"
      subtitle="Mark as Paid to generate a Receipt"
      typeColor="#c2410c"
    >
      <DocListTab
        docType="tax_invoice"
        clients={clients}
        canMarkPaid
      />
    </SalesDocPage>
  );
}
